import {Button, Checkbox, Grid, Modal} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import {PaymentCard as PaymentCardItem} from './PaymentCard'
import {PaymentCardAdd} from './PaymentCardAdd'
import {usePaymentCardList} from './PaymentCardList.hooks'
import type {Props} from './PaymentCardList.types'

export const PaymentCardList = memo(function PaymentCardList(props: Props): React.ReactElement {
  const {fetchCardBoundContext, onAdd} = props
  const {cards, currentCard, changeHandler, translates, buttonProps, agreementProps, notificationsAgreementProps} =
    usePaymentCardList(props)

  return (
    <>
      <Modal.Header text={translates.subtitle} title={translates.title} />
      <Modal.Body p="m">
        <Grid size="m" container>
          {cards.map(c => (
            <Grid key={c.id} xs={6} item>
              <PaymentCardItem card={c} checked={c.id === currentCard?.id} onPress={changeHandler} />
            </Grid>
          ))}
          <Grid xs={6} item>
            <PaymentCardAdd fetchCardBoundContext={fetchCardBoundContext} onAdd={onAdd} />
          </Grid>
          {notificationsAgreementProps && (
            <Grid xs={12} item>
              <Checkbox
                checked={notificationsAgreementProps.checked}
                label={notificationsAgreementProps.children}
                onChange={notificationsAgreementProps.onChange}
              />
            </Grid>
          )}
          {agreementProps && (
            <Grid xs={12} item>
              <Checkbox
                checked={agreementProps.checked}
                error={agreementProps.error}
                label={agreementProps.children}
                onChange={agreementProps.onChange}
              />
            </Grid>
          )}
        </Grid>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Controls>
          <Button {...buttonProps}>{translates.button}</Button>
        </Modal.Footer.Controls>
      </Modal.Footer>
    </>
  )
})
